import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    onClick: (() => void) | undefined;
    orientation: 'horizontal' | 'vertical';
  }>()
  .create(({ onClick, orientation, theme }) => ({
    radialGauge: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: orientation === 'vertical' ? 'column' : 'row',
      height: '100%',
      justifyContent: 'center',
      width: '100%'
    },
    radialGaugeChart: {
      height: '100%',
      width: '100%',
      // Force pointer cursor on all chart elements when clickable
      '& *': {
        cursor: 'inherit !important'
      },
      '& svg': {
        cursor: 'inherit !important'
      },
      '& canvas': {
        cursor: 'inherit !important'
      },
      // Target all possible AG Charts elements
      '& [class*="ag-"]': {
        cursor: 'inherit !important'
      },
      '& text': {
        cursor: 'inherit !important'
      },
      '& path': {
        cursor: 'inherit !important'
      },
      '& circle': {
        cursor: 'inherit !important'
      },
      '& rect': {
        cursor: 'inherit !important'
      }
    },
    radialGaugeContainer: {
      height: '100%',
      width: '100%'
    },
    radialGaugeDescription: {
      ...(orientation === 'vertical' && {
        alignItems: 'center',
        display: 'flex',
        textAlign: 'center',
        width: 'auto'
      }),
      ...(orientation === 'horizontal' && {
        alignItems: 'center',
        display: 'flex',
        height: '100%',
        paddingLeft: '2rem',
        textAlign: 'left',
        width: '65%'
      })
    },
    radialGaugeDescriptionTitle: {
      color: theme.vars.palette.text.secondary,
      fontSize: '1rem',
      paddingBottom: theme.spacing(1)
    },
    radialGaugeNoData: {
      alignItems: 'center',
      borderBottom: 0,
      color: 'var(--mui-palette-text-secondary)',
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
      width: '100%'
    },
    radialGaugeWrapper: {
      cursor: onClick ? 'pointer' : 'default',
      // Ensure cursor style is inherited by child elements
      '& *': {
        cursor: 'inherit'
      },
      ...(orientation === 'vertical' && {
        display: 'flex',
        flexDirection: 'column',
        height: '50%',
        justifyContent: 'flex-end',
        marginBottom: theme.spacing(3),
        width: '100%'
      }),
      ...(orientation === 'horizontal' && {
        alignItems: 'center',
        height: '100%',
        justifyContent: 'center',
        minWidth: '6.25rem',
        width: '35%',
        [theme.breakpoints.up('md')]: {
          width: '20%'
        },
        [theme.breakpoints.up('xl')]: {
          width: '35%'
        }
      })
    }
  }));

export default useStyles;
